module.exports = __webpack_public_path__ + "static/img/cheer4.cf6b6fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/cheer/cheer4.jpg
// module id = rUNI
// module chunks = 1